<mat-dialog-content>
    <section class="success">

        <img src="assets/mascotes/personagemLaranja.png" alt="">
        <h2>Enviado com sucesso!</h2>
        <!-- <a mat-button class="round background-light-yellow " (click)="close()" target="_blank">Ok</a> -->
    </section>
</mat-dialog-content>